import { Stack } from '@mui/material';
import { CustomMetaTitle } from 'Components';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { Title } from './Title';
import { BankDetailsForm } from './BankDetailsForm';

interface IUpdateBankDetails {
  nextStep: () => void;
  currentStepIndex: number;
  stepsLength: number;
}

export const UpdateBankDetails = ({
  nextStep,
  currentStepIndex,
  stepsLength,
}: IUpdateBankDetails) => {
  return (
    <>
      <CustomMetaTitle
        title={`${Dictionary[DICTIONARY.UpdateBankDetails].title} ${Dictionary[
          DICTIONARY.Requests
        ].stepperSrLabel(currentStepIndex, stepsLength)}`}
      />
      <Stack alignItems='center' gap='40px'>
        <Title />
        <BankDetailsForm nextStep={nextStep} />
      </Stack>
    </>
  );
};
